module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', [_c('div', {
    staticClass: "columns is-desktop"
  }, [_c('div', {
    staticClass: "column is-one-third is-offset-one-third"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Welcome to ClassForward!")]), _vm._v(" "), _c('section', {
    staticClass: "mt-4"
  }, [_c('h3', {
    staticClass: "title is-3"
  }, [_vm._v("Finish activating your account")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.reset()
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), (_vm.passwordTooShort) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("This password is too short (8 chars min)")]) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your School Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school),
      expression: "school"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.school = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: _vm.loading && 'is-loading',
    attrs: {
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_vm._v("Activate")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-a4495096"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activate.vue
// module id = 1078
// module chunks = 0